import type { ComponentType } from 'react';

import type { DataCellType } from './DataCell';

import ActionCell, { ActionCellSkeleton } from './ActionCell';
import ChipsCell, { ChipsCellSkeleton } from './ChipsCell';
import CountCell, { CountCellSkeleton } from './CountCell';
import DateTimeCell, { DateTimeCellSkeleton } from './DateTimeCell';
import FileFormatCell, { FileFormatCellSkeleton } from './FileFormatCell';
import FileNameCell, { FileNameCellSkeleton } from './FileNameCell';
import FileSizeCell, { FileSizeCellSkeleton } from './FileSizeCell';
import IdCell, { IdCellSkeleton } from './IdCell';
import MessageCell, { MessageCellSkeleton } from './MessageCell';
import MimeTypeCell, { MimeTypeCellSkeleton } from './MimeTypeCell';
import NumberCell, { NumberCellSkeleton } from './NumberCell';
import StatusCell, { StatusCellSkeleton } from './StatusCell';
import TextCell, { TextCellSkeleton } from './TextCell';
import UserCell, { UserCellSkeleton } from './UserCell';

// Map of cell types to their skeleton components.
// Note: this file intentionally exports non-component constants.
export const DataCellSkeletons: Record<DataCellType, ComponentType | null> = {
  text: TextCellSkeleton,
  number: NumberCellSkeleton,
  date: DateTimeCellSkeleton, // Use DateTimeCellSkeleton for date too
  datetime: DateTimeCellSkeleton,
  time: DateTimeCellSkeleton,
  boolean: null, // No skeleton defined yet
  badge: null, // No skeleton defined yet
  status: StatusCellSkeleton,
  avatar: null, // No skeleton defined yet
  icon: null, // No skeleton defined yet
  actions: null, // No skeleton defined yet
  user: UserCellSkeleton,
  fileSize: FileSizeCellSkeleton,
  fileFormat: FileFormatCellSkeleton,
  fileName: FileNameCellSkeleton,
  mimeType: MimeTypeCellSkeleton,
  id: IdCellSkeleton,
  count: CountCellSkeleton,
  chips: ChipsCellSkeleton,
  action: ActionCellSkeleton,
  message: MessageCellSkeleton,
  custom: null, // Custom cells don't have default skeletons
};

// Ensure tree-shaking keeps skeleton imports when used through this map.
void ActionCell;
void ChipsCell;
void CountCell;
void DateTimeCell;
void FileFormatCell;
void FileNameCell;
void FileSizeCell;
void IdCell;
void MessageCell;
void MimeTypeCell;
void NumberCell;
void StatusCell;
void TextCell;
void UserCell;

